import styled from '@emotion/styled';

const Button = styled.button(({ secondary, theme, style }) => ({
    ...theme.typography.pTiny,
    color: theme.colors.primary.main,
    backgroundColor: secondary ? 'transparent' : theme.colors.primary.contrastColor,
    padding: `${theme.spacing.xxs} ${theme.spacing.s}`,
    border: secondary ? `2px solid ${theme.colors.primary.light}` : 'none',
    borderRadius: theme.spacing.xxxs,
    fontWeight: 600,
    fontSize: '1.125rem',
    opacity: 1,
    transition: theme.transition.default,
    boxShadow: theme.shadow.dropShadow,
    '&:hover': {
        color: secondary ? theme.colors.primary.dark : theme.colors.primary.mainHover,
        backgroundColor: secondary ? theme.colors.primary.light : theme.colors.primary.contrastHover,
        cursor: 'pointer'
    },
    '&:disabled': {
        opacity: 0.5,
        cursor: 'not-allowed'
    },
    ...style
}));

function StyledButton({ children, primary, secondary, text, style={}, ...otherProps }) {
    return <Button secondary={secondary} style={style} {...otherProps}>{children}</Button>;
}

export default StyledButton;
